module.exports = __webpack_public_path__ + "img/user-icon.429a937c.png";